import { createSlice } from '@reduxjs/toolkit';
import { PaymentState } from '../../../types/payment';

// Set the initial state values of the state object that this slice will manage
const INITIAL_STATE: PaymentState = {
  paymentID: null,
  signatoryName: null,
  selectedPaymentMethod: null,

  paymentFees: {
    ccFee: null,
    ccTotal: null,
    achFee: null,
    achTotal: null,
    checkFee: null,
    checkTotal: null,

    breakdown: [], // array of of objects with a label and a value property
  },

  paymentSuccesInfo: null, // should be an object returned from the /check... endpoint
  paymentCheckFailed: false,
};

// Define the slice and generate actions, reducers with createSlice
export const paymentSlice = createSlice({
  name: 'payment',
  initialState: INITIAL_STATE,
  reducers: {
    setPaymentID: (state, action) => {
      state.paymentID = action.payload;
    },
    setSignatoryName: (state, action) => {
      state.signatoryName = action.payload;
    },
    setSelectedPaymentMethod: (state, action) => {
      state.selectedPaymentMethod = action.payload;
    },
    setPaymentFees: (state, action) => {
      state.paymentFees = { ...state.paymentFees, ...action.payload };
    },
    setPaymentSuccessInfo: (state, action) => {
      state.paymentSuccesInfo = action.payload;
    },
    setPaymentCheckFailed: (state, action) => {
      state.paymentCheckFailed = action.payload;
    },
    resetPaymentState: () => INITIAL_STATE,
  },
});

// Export actions that were generated by createSlice
export const {
  setPaymentID,
  setSignatoryName,
  resetPaymentState,
  setPaymentFees,
  setSelectedPaymentMethod,
  setPaymentSuccessInfo,
  setPaymentCheckFailed,
} = paymentSlice.actions;

// Export combined reducer that was generated by createSlice
// (this is a single reducer which is a combination of all reducers in the slice... it basically puts them in a switch statement)
export default paymentSlice.reducer;
